import IconsChevronDown from "glesys-controlpanel/components/icons/chevron-down";
import Header from "glesys-controlpanel/components/entity/header";
import Fields from "glesys-controlpanel/components/entity/fields";
import Menu, { MenuAnchor } from "glesys-controlpanel/components/entity/menu";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

<template>
  <div
    class="relative [anchor-scope:all] border border-gray-200 bg-white rounded-sm text-base"
    {{mergeClasses}}
    ...attributes
  >
    <details class="group/entity">
      <summary
        class="group block cursor-pointer list-none rounded-sm [&::-webkit-details-marker]:hidden hover:bg-gray-50 group-open/entity:border-b group-open/entity:border-gray-200 group-open/entity:rounded-b-none"
        data-test-entity-toggle
      >
        <Header @title={{@title}} @key={{@key}} @workflowState={{@workflowState}} @managedHosting={{@managedHosting}}>
          {{#if @hasActions}}
            <MenuAnchor />
          {{/if}}
          <span
            class="w-9 h-8 flex items-center justify-center rounded-sm bg-white border border-gray-200 text-gray-600 group-hover:border-gray-300 group-hover:text-gray-800"
          >
            <IconsChevronDown class="transition duration-300 group-open/entity:rotate-180" />
          </span>
        </Header>
        {{#if @hasFields}}
          <Fields @status={{@status}}>
            {{yield to="fields"}}
          </Fields>
        {{/if}}
      </summary>
      <div class="px-4 py-3 sm:px-6 sm:py-4" data-test-entity-details>
        {{yield to="details"}}
      </div>
    </details>
    {{#if @hasActions}}
      <Menu @title={{@title}}>
        {{yield to="actions"}}
      </Menu>
    {{/if}}
  </div>
</template>
